import React, { useState } from "react";
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, LinearProgress } from "@material-ui/core";
import { PlainTextField } from "components";
import { useSnackbar } from "notistack";
import authI18n from "features/auth/i18n";
import i18n from "./i18n";

// prop types
interface ConfirmSignupDialogProps {
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    clubId?: string;
    showDialog: boolean;
    onResendConfirmationCode: (email: string) => void;
    onConfirmUser: (email: string, password: string, firstName: string, lastName: string, code: string, clubId?: string) => void;
    onCompleteRegistration: () => void;
}

// forgot password dialog
const ConfirmSignupDialog = ({ email, password, firstName, lastName, clubId, showDialog, onResendConfirmationCode, onConfirmUser, onCompleteRegistration: finishRegistration }: ConfirmSignupDialogProps) => {
    // snackbar
    const { enqueueSnackbar } = useSnackbar();

    // ui state
    const [code, setCode] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [authError, setAuthError] = useState<string | undefined>();

    const submitConfirmation = async () => {
        if (code === "") {
            enqueueSnackbar(i18n.confirmationCodeRequired, { variant: "error" });
            return;
        }

        setIsLoading(true);
        const error = await onConfirmUser(email, password, firstName, lastName, code, clubId) as unknown as string;
        setAuthError(error);
        setIsLoading(false);
        if (error) return;
        finishRegistration();
    };

    const requestResendCode = async () => {
        setIsLoading(true);
        const error = await onResendConfirmationCode(email) as unknown as string;
        setAuthError(error);
        setIsLoading(false);
        if (error) return;
        enqueueSnackbar(i18n.confirmSignupCodeSentDesc, { variant: "success" });
    };

    // render
    return (
        <Dialog
            open={showDialog}
        // onClose={onClose}
        >
            <DialogTitle>{i18n.confirmSignup}</DialogTitle>
            <DialogContent dividers>

                {/* description text */}
                <DialogContentText>
                    {i18n.confirmSignupDesc}
                </DialogContentText>

                {/* Verification Code */}
                <PlainTextField
                    autoFocus
                    disabled={isLoading}
                    error={!!authError}
                    helperText={(authError!) && authI18n.errors[authError!]}
                    label={i18n.verificationCode}
                    type="password"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                />

            </DialogContent>
            {isLoading && <LinearProgress />}
            <DialogActions>
                <Button color="secondary" onClick={requestResendCode}>
                    {i18n.resendVerificationCode}
                </Button>
                <Button color="primary" onClick={submitConfirmation} disabled={isLoading}>
                    {i18n.confirm}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmSignupDialog;
